import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MapPage from "../pages/map/page";
import MyPage from "../pages/mypage/page";
import AuctionPage from "../pages/auction/page";
import RankingPage from "../pages/ranking/page";
import CompanyPage from "../pages/company/page";
import PowerPlantPage from "../pages/powerplant/page";
import HousePage from "../pages/house/page";
import StockMarketPage from "../pages/stock-market/page";
import AuthCallbackPage from "../pages/auth-callback/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/map", element: <MapPage /> },
  { path: "/mypage", element: <MyPage /> },
  { path: "/auction", element: <AuctionPage /> },
  { path: "/ranking", element: <RankingPage /> },
  { path: "/stock-market", element: <StockMarketPage /> },
  { path: "/company/:companyId", element: <CompanyPage /> },
  { path: "/powerplant/:plantId", element: <PowerPlantPage /> },
  { path: "/house/:houseId", element: <HousePage /> },
  { path: "/auth/callback", element: <AuthCallbackPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
